import { observable, computed } from 'mobx'
import moment from 'moment'
import Api from './api'
import { Modal } from 'hljd'
import { NO_ORDER_TAKING } from './constant'
import { isSiDaMember, groupHasNoMember, isSanDaTeam, isSiYiTeam } from '@util'

export default class {
  constructor(isTeamSchedule) {
    this.isTeamSchedule = isTeamSchedule
    this.getGroupMembers()
    this.getMemberScheduleList()
    this.getScheduleSlot()
  }

  @observable activeDate = moment() // 当前日期
  @observable groupMembers = [] // 团队组员
  @observable groupMemberId = 0 // 团队组员id
  @observable schedules = [] // 日程列表 年
  @observable scheduleSlot = [] // 时间段定义
  @observable modalVisable = false // 弹框
  @observable isTeamSchedule = false // true团队管理下的团队档期
  @observable hotModalVisible = false // 顶部提示框中点击查看详情的人气四大弹框
  form = null

  @computed
  get months() {
    const activeYear = this.activeDate.get('Y')

    const months = Array(12)
      .fill()
      .map((item, index) => {
        const currentMonth = moment({ y: activeYear, M: index })
        const currentMonthFmt = currentMonth.format('YYYY-MM')
        const currentMonthData =
          this.schedules.find(item => item.month === currentMonthFmt) || {}

        return {
          currentMonth,
          ...currentMonthData
        }
      })
    return months
  }

  @computed
  get monthSchedules() {
    const currentMonthFmt = this.activeDate.format('YYYY-MM')
    const currentMonthData =
      this.schedules.find(item => item.month === currentMonthFmt) || {}
    return currentMonthData.list || []
  }

  @computed
  get daySchedules() {
    const currentDayFmt = this.activeDate.format(__FMT1__)
    const currentDayData =
      this.monthSchedules.find(item => item.day == currentDayFmt) || {}
    return currentDayData.list || []
  }

  getGroupMembers = async () => {
    const { success, data } = await Api.getGroupMemberList({
      need_all: 1
    })

    if (success) {
      this.groupMembers = data
    }
  }

  getMemberScheduleList = async () => {
    const request =
      isSiDaMember() && !this.isTeamSchedule
        ? Api.getScheduleList
        : Api.getMemberScheduleList
    const { success, data } = await request({
      status: 0,
      merchant_id: isSanDaTeam() ? this.groupMemberId : null,
      emcee_member_id: isSiYiTeam() ? this.groupMemberId : null,
      year: this.activeDate.get('y')
    })

    if (success) {
      this.schedules = data.list || []
    }
  }

  onDateChange = date => {
    if (date.get('y') !== this.activeDate.get('y')) {
      this.activeDate = date
      this.getMemberScheduleList()
    } else {
      this.activeDate = date
    }
  }

  onGroupMemberChange = val => {
    this.groupMemberId = val
    this.getMemberScheduleList()
  }

  getScheduleSlot = async () => {
    const { success, data } = await Api.getScheduleSlot({
      need_all: 1
    })

    if (success) {
      this.scheduleSlot = data
    }
  }

  showModalVisable = record => async () => {
    if (groupHasNoMember('您暂无团队成员，无法新建档期，请先添加团队成员')) {
      return
    }

    if (record) {
      if (this.isTeamSchedule) {
        return
      }

      const { data, success } = await Api.getScheduleDetail({
        id: record.id
      })
      if (success) {
        this.modalVisable = true
        const {
          time,
          date,
          merchant = {},
          slot,
          images = [],
          id,
          actualPrice,
          deposit,
          emceeMember = {},
          ...rest
        } = data
        if (slot == NO_ORDER_TAKING) {
          this.form.setFieldsValue({
            id,
            date: moment(date),
            slot,
            merchantId: isSanDaTeam() ? merchant.id : null,
            emcee_member_id: isSiYiTeam() ? emceeMember.id : null
          })
        } else {
          this.form.setFieldsValue({
            id,
            date: moment(date),
            slot,
            time: time ? moment(time, 'HH:mm') : null,
            merchantId: isSanDaTeam() ? merchant.id : null,
            emcee_member_id: isSiYiTeam() ? emceeMember.id : null,
            actualPrice: +actualPrice ? actualPrice : undefined,
            deposit: +deposit ? deposit : undefined,
            images: images.map(({ coverPath, ...other }) => ({
              imagePath: coverPath,
              ...other
            })),
            ...rest
          })
        }
      }
    } else {
      this.modalVisable = true
      this.form.setFieldsValue({
        date: moment(this.activeDate)
      })
    }
  }

  hideModalVisable = () => {
    this.modalVisable = false
    this.form.resetFields()
  }

  setForm = form => {
    this.form = form
  }

  onSave = () => {
    this.form.validateFields(async (errors, values) => {
      if (!errors) {
        const checkParams = {
          date: values.date.format(__FMT1__),
          slot: values.slot,
          merchant_id: isSanDaTeam() ? values.merchantId : null,
          emcee_member_id: isSiYiTeam() ? values.emcee_member_id : null,
          id: values.id
        }

        const { data, success } = await Api.checkSchedule(checkParams)
        if (success) {
          // status，0无冲突，1当前日期不接单，2当前日期已存在档期
          if (data.status === 0) {
            // TODO 直接新增
            this.onAddApiSubmit(values)
          } else {
            Modal.confirm({
              title:
                data.status == 1
                  ? '该成员当前日期已设置不接单'
                  : '该成员当前时间已存在档期',
              content:
                data.status == 1 ? '请确认是否接单!' : '请确认是否重复接单！',
              okText: '确认保存档期',
              onOk: async () => {
                this.onAddApiSubmit(values)
              }
            })
          }
        }
      }
    })
  }

  onAddApiSubmit = async values => {
    const { date, time, ...rest } = values
    let submitApi = Api.addSchedule
    if (values.id) {
      submitApi = Api.editSchedule
    }
    const { success } = await submitApi({
      date: date.format(__FMT1__),
      time: time && time.format('HH:mm'),
      ...rest
    })

    if (success) {
      this.hideModalVisable()
      this.getMemberScheduleList()
    }
  }

  onDeleteSubmit = async () => {
    Modal.confirm({
      title: '提示',
      content: '你是否确认删除这项内容?',
      okText: '确定',
      onOk: async () => {
        const id = this.form.getFieldValue('id')
        const { success } = await Api.deleteSchedule({ id })
        if (success) {
          this.hideModalVisable()
          this.getMemberScheduleList()
        }
      }
    })
  }

  onChangeStatus = (record, status) => async () => {
    if (record.status != status) {
      const { success } = await Api.changeStatus({
        id: record.id,
        status: +status
      })

      if (success) {
        this.getMemberScheduleList()
      }
    }
  }

  toggleHotModalVisible = visible => () => {
    this.hotModalVisible = visible
  }
}
